module.exports = __webpack_public_path__ + "static/media/Curoflow telemedicine platform in Spain.a98468d2.webp";